import { School } from '../school';
import { Payment } from '../payment';
import { Student } from '../student';
import { Enrollment } from '../enrollment';
import { Card } from '../card';
import { Reservation } from '../reservation';
import { EventReservation } from '../event-reservation';

export class PaymentItem {
    constructor(
        public id?: number,
        public amount?: number,
        public school?: School,
        public payment?: Payment,
        public beneficiary?: Student,
        public card?: Card,
        public reservation?: Reservation,
        public eventReservation?: EventReservation,
        public createdDate?: Date,
        public backofficePaymentIntentId?: string
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/payment-item/payment-item.model.ts